import { VStack } from 'native-base';
import { Caption, H3 } from '~/shared/Typography';
import Pressable from '~/shared/Pressable';
import React from 'react';
import { SpIcon } from '~/shared/Icon';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useI18n, useTheme } from '@springbig/shared';
import { Button } from '../Theme';

type PopUpProps = {
    title: string;
    description: string;
    button: string;
    type?: 'warning' | 'info';
    isClosable?: boolean;
    isDismissable?: boolean;
    onProceed: () => void;
    onCancel?: () => void;
    onDismiss?: () => void;
};

const PopUpBanner = ({
    title,
    description,
    button,
    isClosable = true,
    isDismissable = false,
    onProceed,
    onCancel,
    onDismiss,
}: PopUpProps) => {

    const { t } = useI18n();

    const {
        button_text
    } = useTheme();

    return (
        <VStack
            bg={'red'}
            p={4}
            space={4}
            alignItems={'center'}
            textAlign={'center'}
            w={'100%'}
            position={'relative'}
        >
            <VStack w={'100%'}>
                { isClosable &&
                    <Pressable
                        position={'absolute'}
                        onPress={onCancel}
                        color={button_text}
                    >
                        <SpIcon
                            icon={faTimes}
                            color={button_text}
                        />
                    </Pressable>
                }
                <H3 color={button_text} px={10}>
                    { title }
                </H3>
            </VStack>
            <Caption color={button_text}>
                { description }
            </Caption>
            <Button
                borderRadius={32}
                px={4}
                onPress={onProceed}
                text={button}
                variant={'danger'}
            />
            { isDismissable &&
                <Pressable onPress={onDismiss}>
                    <Caption>{ t('subscriptions.popups.sub_prompt.dismiss') }</Caption>
                </Pressable>
            }
        </VStack>
    );
};

export default PopUpBanner;
